import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import moment from 'moment'

class LastActive extends Component {
  static propTypes = {
    value: PropTypes.object,
    label: PropTypes.string
  }

  renderDate = () => {
    const { value, label } = this.props
    if (!value) return null

    const lastActiveDate = value.lastActive
      ? moment(value.lastActive).format('MMM GGGG')
      : '-'

    return (
      <div>
        <h1>{lastActiveDate}</h1>
        <span>{label}</span>
      </div>
    )
  }

  render () {
    return <div className='floating'>{this.renderDate()}</div>
  }
}

export default observer(LastActive)
